(function(){
  var _apply=null, _closeD=null, _drawerEl=null, _applyLayoutRef=null, _refineRef=null, _sideHidden=false; // current page's handlers + wide-mode show/hide preference (persists across soft nav)
  // WIDE-MODE SIDEBAR PREFERENCE. Hide/Show Filters used to be a per-page DEFAULT recomputed on every
  // page (see the _sideHidden assignment below), so a shopper who hid the sidebar met it again on the
  // next grid and one who wanted it never got it anywhere but Shop All. It is a preference, so it is
  // remembered on the device — the same shape as cvn_layout and the density cookie.
  var CVN_SIDE_KEY='cvn_side_filters';
  function cvnSidePref(){ try{ var v=localStorage.getItem(CVN_SIDE_KEY); if(v==='off') return true; if(v==='on') return false; }catch(e){} return null; }
  function cvnSideSave(hidden){ try{ localStorage.setItem(CVN_SIDE_KEY, hidden?'off':'on'); }catch(e){} }
  // PHONE ONLY — defined at IIFE top so EVERY call site (renderBar, the ResizeObserver, and the on-load
  // triggers) can reach it. On a narrow screen the four bar items (Filters, N-products count, density,
  // Sort) don't wrap or shrink, so a long count pushes Sort off the right edge. Measure the row's natural
  // width vs the space available and scale the whole row down just enough to fit (via `zoom`, which shrinks
  // layout size too), clamped so it never gets unreadably small. Desktop is never touched (zoom reset).
  function _fitBar(){
    var row=document.querySelector('.cvn-fbar-row'); if(!row) return;
    row.style.zoom='';                                   // reset first so we measure the true natural width
    if(!window.matchMedia('(max-width:749px)').matches) return;   // phone only
    var avail=row.clientWidth, need=row.scrollWidth;
    if(avail<=0) return;                                 // not laid out yet — don't shrink to the floor by mistake
    if(need>avail+1){ row.style.zoom = Math.max(0.6, avail/need); }
  }
  function initFilter(){
  var el = document.getElementById('cvn-filter-data');
  if (!el) return;
  // Group + vibe-category pages render their directory tiles ABOVE the product grid (v61); the bar and drawer
  // are wired there like on any other grid page. (Until v61 the directory replaced the grid, and this used to
  // hide the bar whenever .cvn-tiles was on the page.)
  var _dw = document.getElementById('cvn-fdrawer');
  if (!_dw || _dw.getAttribute('data-cvn-wired')==='1') return; // this page's drawer is already wired
  _dw.setAttribute('data-cvn-wired','1');
  var DATA = {}; try { DATA = JSON.parse(el.textContent); } catch(e){ return; }
  // WIDE default when the shopper has never chosen: SHOWN on the browse-everything grids (Shop All and
  // the Collections hub — pages whose whole job is narrowing a large set), HIDDEN on the smaller ones.
  // ⚠ Once they DO choose, that choice wins on every grid page; this line only supplies the first answer.
  var _cvnSideHubs = ',all,all-products,browse,';
  var _cvnIsHub = !!(DATA && DATA.handle && _cvnSideHubs.indexOf(',' + DATA.handle + ',') > -1);
  var _cvnPref = cvnSidePref();
  _sideHidden = (_cvnPref === null) ? !_cvnIsHub : _cvnPref;

  var FAMILIES = [
    ['Black',  '#1A1A1A', ['black']],
    ['Gray',   '#9CA0A5', ['grey','gray','silver','charcoal','slate','steel','graphite','storm','pewter','gunmetal','ash']],
    ['White',  '#FFFFFF', ['white','chalk','pearl','eggshell']],
    ['Natural','#EADFC8', ['natural','cream','sand','ivory','bone','oatmeal','vintage white']],
    ['Brown',  '#7B4A2E', ['brown','chocolate','toast','tan','oyster','camel','mocha','coffee','clay','desert','chestnut','walnut','espresso','khaki','beige']],
    ['Blue',   '#3A63C0', ['blue','navy','royal','carolina','denim','indigo','aqua','sky','ocean','teal','turquoise','mint']],
    ['Green',  '#5A8F5C', ['green','sage','forest','olive','army','moss','kiwi','kelly','leaf','emerald']],
    ['Red',    '#C0392B', ['red','maroon','burgundy','cardinal','wine','cranberry','brick','scarlet']],
    ['Pink',   '#E57BA6', ['pink','rose','blush','fuchsia','magenta','flamingo']],
    ['Purple', '#7D4CA8', ['purple','lilac','violet','lavender','plum','orchid','grape','eggplant','aubergine']],
    ['Orange', '#E8863B', ['orange','coral','peach','apricot','terracotta','tangerine','salmon','rust']],
    ['Yellow', '#E8C33B', ['yellow','gold','mustard','lemon','maize','daisy','honey']]
  ];
  var NAME_OVERRIDE = [
    ['Green',  ['heather mint','prism mint']], // the heather mints read green; plain "Mint" stays blue (below)
    ['Natural', ['natural','cream','sand','vintage white','heather dust','ivory','oatmeal','vanilla']],
    ['White',  ['white','chalk','pearl','eggshell','bone']],
    ['Blue',   ['navy','royal','indigo','mint']],
    ['Red',    ['maroon','burgundy','cardinal','wine','cranberry','brick','coral']],
    ['Green',  ['sage','forest','olive','army','military','emerald','moss','hunter','bottle green']],
    ['Purple', ['purple','lavender','violet','plum','orchid','grape','eggplant','aubergine']],
    ['Yellow', ['yellow','maize','daisy','lemon','canary','gold','mustard']],
    ['Pink',   ['pink','rose','blush','fuchsia','magenta','flamingo','peach','lilac']],
    ['Orange', ['orange','apricot','tangerine','salmon','rust']],
    ['Gray',   ['charcoal','graphite','asphalt','gunmetal','pewter','slate','ash']],
    ['Black',  ['black']],
    ['Brown',  ['brown','chocolate','toast','tan','oyster','camel','khaki','beige','biscuit','coffee','espresso','mocha','chestnut','walnut','clay','desert']]
  ];
  var FAM_ORDER = ['White','Black','Natural','Brown','Gray','Red','Pink','Blue','Green','Purple','Orange','Yellow'];
  function famOf(name){
    var n = String(name).toLowerCase();
    for (var o=0;o<NAME_OVERRIDE.length;o++){ var kw=NAME_OVERRIDE[o][1]; for (var q=0;q<kw.length;q++){ if (n.indexOf(kw[q])>-1) return NAME_OVERRIDE[o][0]; } }
    var hx = (DATA.hex && DATA.hex[name]) || (window.CVN_HEX && window.CVN_HEX[name]);
    if (hx) return famFromHex(hx);
    for (var i=0;i<FAMILIES.length;i++){ var kws=FAMILIES[i][2]; for (var j=0;j<kws.length;j++){ if (n.indexOf(kws[j])>-1) return FAMILIES[i][0]; } }
    return 'Other';
  }
  function famFromHex(hx){
    hx = String(hx).replace('#','');
    if (hx.length !== 6) return 'Other';
    var r=parseInt(hx.substr(0,2),16)/255, g=parseInt(hx.substr(2,2),16)/255, b=parseInt(hx.substr(4,2),16)/255;
    var mx=Math.max(r,g,b), mn=Math.min(r,g,b), d=mx-mn, l=(mx+mn)/2, s=d===0?0:d/(1-Math.abs(2*l-1)), h=0;
    if(d!==0){ if(mx===r) h=60*(((g-b)/d)%6); else if(mx===g) h=60*((b-r)/d+2); else h=60*((r-g)/d+4); }
    if(h<0)h+=360;
    if(l>0.9&&s<0.3) return 'White';
    if(l<0.12) return 'Black';
    if(s<0.12) return 'Gray';
    if(h<12||h>=346) return 'Red';
    if(h<45) return (l>0.6?'Brown':'Orange');
    if(h<70) return 'Yellow';
    if(h<170) return 'Green';
    if(h<255) return 'Blue';
    if(h<300) return 'Purple';
    return 'Pink';
  }
  function famColor(fam){ for(var i=0;i<FAMILIES.length;i++){ if(FAMILIES[i][0]===fam) return FAMILIES[i][1]; } return '#bbbbbb'; }
  function lightnessOf(hex){ hex=String(hex).replace('#',''); if(hex.length!==6) return 0.5; var r=parseInt(hex.substr(0,2),16),g=parseInt(hex.substr(2,2),16),b=parseInt(hex.substr(4,2),16); return (Math.max(r,g,b)+Math.min(r,g,b))/510; }
  function hexOf(label,fam){ return (DATA.hex&&DATA.hex[label])||(window.CVN_HEX&&window.CVN_HEX[label])||famColor(fam); }
  function famDistinctCounts(pc){
    if(!pc||!pc.length) return null;
    var m={};
    pc.forEach(function(names){ var seen={}; for(var i=0;i<names.length;i++){ var f=famOf(names[i]); if(f!=='Other') seen[f]=1; } for(var k in seen) m[k]=(m[k]||0)+1; });
    return m;
  }
  var _blCache={}, _blFetching={};
  function colorParamName(){ var cf=findFilter('color'); return cf?cf.param:'filter.v.option.color'; }
  function sigOf(p){ var s=[]; p.forEach(function(v,k){ s.push(k+'='+v); }); s.sort(); return s.join('&'); }
  // The section only emits per-product pc/pt for ONE page (250 products), so on a >250 collection
  // (Shop All) counts computed off a single page miss everything past product 250. fetchAllPages
  // walks every page for `params` and merges pc/pt, so counts/availability reflect ALL matching
  // products. Capped at 8 pages (2000) for safety; cached by the effective filter set.
  function fetchAllPages(params, cb){
    var acc={pc:[],pt:[]};
    function page(n){
      var pp=new URLSearchParams(params.toString()); pp.delete('page'); if(n>1) pp.set('page',n);
      return fetch(fetchUrl(pp)).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html'); var nd=doc.getElementById('cvn-filter-data');
        var D2={}; try{ D2=JSON.parse(nd.textContent); }catch(e){}
        acc.pc=acc.pc.concat(D2.pc||[]); acc.pt=acc.pt.concat(D2.pt||[]);
        var pages=Math.min(8,Math.max(1,Math.ceil((D2.count||0)/250)));
        if(n<pages) return page(n+1);
      });
    }
    return page(1).then(function(){ cb(acc); }).catch(function(){ cb(acc); });
  }
  // Baseline per-product data with ONE facet's param stripped, so that facet's counts reflect the
  // OTHER active filters but not its own selections. Keyed by the effective filter set (so the color
  // and tag baselines share a fetch when the stripped sets match). Fetches EVERY page unless the
  // current DATA already holds the whole collection (this facet empty AND <=250 products total).
  function stripBaseline(stripParam, field){
    var p=curParams(); p.delete(stripParam); p.delete('page');
    var key=sigOf(p);
    if(_blCache[key]) return _blCache[key][field]||[];
    if(curParams().getAll(stripParam).length===0 && (DATA.count||0)<=250){ return DATA[field]||[]; }
    if(!_blFetching[key]){ _blFetching[key]=1;
      fetchAllPages(p, function(acc){ _blCache[key]=acc; delete _blFetching[key];
        if(panelVisible()){ var _st=body.scrollTop; renderDrawer(); body.scrollTop=_st; }
      });
    }
    return DATA[field]||[];
  }
  function baselinePc(){ return stripBaseline(colorParamName(),'pc'); }
  /* Cross-grey baselines for the two browse facets are plain stripBaseline calls now — dropping
     ONE PARAM is exactly "drop one family", since Collections and Vibes no longer share a param.
     (The old tagBaselinePt prefix-dropper died with the shared tag param.) */
  function tagCounts(pt){ var m={}; (pt||[]).forEach(function(tags){ var seen={}; for(var i=0;i<tags.length;i++){ var t=String(tags[i]).toLowerCase(); if(t&&!seen[t]){ seen[t]=1; m[t]=(m[t]||0)+1; } } }); return m; }
  function partAvail(arr,cf){ var av=[],un=[]; arr.forEach(function(x){ (cf(x)>0?av:un).push(x); }); return av.concat(un); }
  // Collections/Vibes: HIDE non-applicable entries (0 products under the other active filters)
  // instead of greying them; always keep an actively-selected entry so it can be removed.
  function availOnly(arr,cf,af){ return arr.filter(function(x){ return cf(x)>0 || (af&&af(x)); }); }
  // Three tiers for the cross-section case: HIDE when a NON-tag filter (colour/size/type/price)
  // leaves zero products (noneFn), GREY + demote when the OTHER tag family's selection leaves zero
  // (crossFn), else available on top. An actively-selected entry is never hidden or greyed.
  // Returns { list:[display order], grey:Set } — grey members render with cvn-unavail.
  function tierize(arr,crossFn,noneFn,af){
    var avail=[], grey=[], gset=[];
    arr.forEach(function(x){ var act=af&&af(x);
      if(!(noneFn(x)>0 || act)) return;                 // hidden by a non-tag filter
      if(crossFn(x)>0 || act){ avail.push(x); } else { grey.push(x); gset.push(x); }
    });
    return { list: avail.concat(grey), grey: gset };
  }

  var SIZE_ORDER = ['xxs','xs','s','m','l','xl','2xl','xxl','3xl','xxxl','4xl','5xl','6xl','11 oz','15 oz','20 oz'];
  function sizeRank(v){ var i=SIZE_ORDER.indexOf(String(v).toLowerCase()); return i<0?900:i; }
  function tc(slug){ return String(slug).split('-').join(' ').replace(/(^|\s)\S/g, function(c){return c.toUpperCase();}); }

  var drawer=document.getElementById('cvn-fdrawer'), body=document.getElementById('cvn-fbody'),
      chips=document.getElementById('cvn-fchips'), badge=document.getElementById('cvn-fcount'),
      results=document.getElementById('cvn-fresults'), clearBtn=document.getElementById('cvn-fclear'),
      sortSel=document.getElementById('cvn-sort'), applyBtn=document.getElementById('cvn-fview');
  if(!drawer||!body) return;
  // Relabel "Sort" -> "Sort:" (drop the `for` so clicking the label doesn't forward a click to the hidden
  // select and re-toggle the menu) and order the right side as … count · sort. Chips placement (bar vs
  // drawer) is decided per-breakpoint in applyLayout.
  (function(){ var _row=document.querySelector('.cvn-fbar-row');
    if(_row){
      var _lbl=_row.querySelector('.cvn-fsort-lbl'); if(_lbl){ _lbl.textContent='Sort:'; _lbl.removeAttribute('for'); }
      var _sort=_row.querySelector('.cvn-fsort'), _res=document.getElementById('cvn-fresults');
      if(_sort&&_res){ _row.appendChild(_res); _row.appendChild(_sort); }
    }
    // Count next to the drawer's "Filters" title ("N out of M noun" when filtered, else "M noun").
    var _hd=document.querySelector('.cvn-fdrawer-head'), _tt=_hd&&_hd.querySelector('.cvn-fdrawer-title');
    if(_hd&&_tt&&!_hd.querySelector('.cvn-fdrawer-count')){
      var _wrap=document.createElement('span'); _wrap.className='cvn-fdrawer-titlewrap';   // Filters + count baseline-aligned, centred as a unit
      _tt.parentNode.insertBefore(_wrap,_tt); _wrap.appendChild(_tt);
      var _dc=document.createElement('span'); _dc.className='cvn-fdrawer-count'; _wrap.appendChild(_dc);
    }
  })();
  // PHONE sticky bar — same approach as the gallery's sticky twin images: NATIVE position:sticky (no JS
  // pinning). Native sticky only holds within its containing block, and #cvn-fbar ships inside its own short
  // section wrapper, so first we REPARENT it to sit right before the product-grid SECTION — its parent then
  // becomes the tall <main>, and sticky holds across the whole grid. CSS (phone, filters active) does the
  // sticking; JS only keeps --cvn-sticky-top equal to the site header's live bottom so the bar rests just
  // below it and follows the header as it SHRINKS on scroll.
  var _bar=document.getElementById('cvn-fbar');
  (function(){ if(!_bar) return; var g=document.getElementById('product-grid'); var gs=g&&g.closest('.shopify-section'); if(gs&&gs.parentNode&&_bar.parentNode!==gs.parentNode) gs.parentNode.insertBefore(_bar,gs); })();
  var _HDR_SEL=['sticky-header','.header-wrapper','.section-header','#shopify-section-header','header'];
  // Return the FIRST (innermost/most-specific) header pinned at the top — that's the element that actually
  // SHRINKS. Taking the max across candidates grabbed the section-header placeholder (which keeps the
  // original height), leaving a gap once the real header shrank.
  function _headerBottom(){ for(var i=0;i<_HDR_SEL.length;i++){ var els=document.querySelectorAll(_HDR_SEL[i]); for(var j=0;j<els.length;j++){ var r=els[j].getBoundingClientRect(); if(r.height>0 && r.top<=1 && r.bottom>0) return Math.round(r.bottom); } } return 0; }
  function _syncTop(){ document.documentElement.style.setProperty('--cvn-sticky-top', _headerBottom()+'px'); }
  (function(){ var tick=false; function on(){ if(tick) return; tick=true; requestAnimationFrame(function(){ _syncTop(); tick=false; }); }
    _syncTop(); window.addEventListener('scroll',on,{passive:true}); window.addEventListener('resize',on,{passive:true});
    if(window.ResizeObserver){ var _ro=new ResizeObserver(on); _HDR_SEL.forEach(function(s){ var el=document.querySelector(s); if(el) _ro.observe(el); }); }   // header shrink can settle after the last scroll event
  })();
  var collapsed={}, colorExpanded={}, nodeOpen={};

  function curParams(){ return new URLSearchParams(location.search); }
  function urlFor(p){ var q=p.toString(); return DATA.collUrl + (q?('?'+q):''); }
  // Apparel sizes (S/M/L…) and drinkware sizes (oz) share ONE Shopify "Size" facet, and facets are
  // AND-ed with product type — so picking Medium would drop every mug (mugs have no Medium). To make
  // a size apply only to its own product domain, when a size is chosen for one domain but not the
  // other, we ALSO send the whole OTHER domain's sizes: the facet OR then lets the other domain pass
  // unconstrained. Picking Medium => {Medium}+all oz => apparel filtered to M, all mugs kept. Picking
  // 15oz => {15oz}+all apparel sizes => mugs filtered to 15oz, all apparel kept. Only affects the
  // FETCH sent to Shopify; the drawer's own checkbox state stays the user's raw pick.
  function isOzSize(v){ return String(v).toLowerCase().indexOf('oz')>-1; }
  function augmentParams(p){
    var sf=findFilter('size'); if(!sf) return p;
    var sel=p.getAll(sf.param); if(!sel.length) return p;
    var appSel=sel.some(function(v){return !isOzSize(v);}), drkSel=sel.some(isOzSize);
    if(appSel===drkSel) return p; // both domains picked (or neither) — OR already does the right thing
    var selDom=appSel?'app':'drink';
    var out=new URLSearchParams(p.toString()); var have=out.getAll(sf.param);
    sf.values.forEach(function(v){
      var lv=String(v.value).toLowerCase();
      var d=isOzSize(v.value)?'drink':(/one\s*size|^os$|^one$/.test(lv)?'other':'app');
      // add every size NOT in the selected domain so those products (mugs, and one-size totes) pass
      if(d!==selDom && have.indexOf(v.value)<0) out.append(sf.param,v.value);
    });
    return out;
  }
  function fetchUrl(p){ return urlFor(augmentParams(p)); }

  function findFilter(kind){
    for(var i=0;i<DATA.filters.length;i++){ var f=DATA.filters[i]; var pn=String(f.param).toLowerCase();
      if(kind==='color'&&pn.indexOf('option.color')>-1) return f;
      if(kind==='size'&&pn.indexOf('option.size')>-1) return f;
      if(kind==='type'&&pn.indexOf('product_type')>-1) return f;
      if(kind==='tag'&&pn.indexOf('.tag')>-1&&pn.indexOf('option')<0) return f;
      if(kind==='coll'&&pn.indexOf('browse_collection')>-1) return f;
      if(kind==='vibe'&&pn.indexOf('browse_vibes')>-1) return f;
      if(kind==='price'&&f.type==='price_range') return f;
    }
    return null;
  }
  /* BROWSE FILTERING RIDES TWO METAFIELD FACETS (filter_metafields_plan.md). The tag facet cannot
     carry the taxonomy values on this store (S&D's tag universe excludes them at our 5,000-tag
     scale), so the drawer COMMITS browse_collection (the whole group/niche/micro tree — ONE value
     space, so mixed-level ticks OR like they always did) and browse_vibes (vibes; the two facets
     AND against each other, which is the correct niche∩vibe). COUNTS still come from the
     products' own tags (pt) — tags remain the collections' membership projection — so cC/cV keys
     stay 'niche:x'/'vibe:y' while the APPLIED values are bare slugs. */
  function collParam(){ var f=findFilter('coll'); return f?f.param:'filter.p.m.custom.browse_collection'; }
  function vibesParam(){ var f=findFilter('vibe'); return f?f.param:'filter.p.m.custom.browse_vibes'; }

  // A collapsible section. Its open/closed state lives in collapsed[key] and PERSISTS across
  // re-renders (the `open` arg only seeds the first render) so clicking a filter inside no
  // longer snaps the section shut.
  function grpEl(key,title,open){
    if(collapsed[key]===undefined) collapsed[key]=(open===false);
    var g=document.createElement('div'); g.className='cvn-fgrp'+(collapsed[key]?' is-collapsed':'');
    var h=document.createElement('button'); h.type='button'; h.className='cvn-fgrp-head';
    h.innerHTML='<span>'+title+'</span><span class="cvn-caret" aria-hidden="true"><svg viewBox="0 0 20 20" width="13" height="13"><path d="M5 8l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    var b=document.createElement('div'); b.className='cvn-fgrp-body';
    h.addEventListener('click',function(){ g.classList.toggle('is-collapsed'); collapsed[key]=g.classList.contains('is-collapsed'); });
    g.appendChild(h); g.appendChild(b); return {g:g,b:b};
  }

  function pHas(name,val){ return curParams().getAll(name).indexOf(val)>-1; }
  function pToggle(name,val){ var pp=curParams(); var arr=pp.getAll(name); pp.delete(name); if(arr.indexOf(val)>-1){ arr.forEach(function(x){ if(x!==val) pp.append(name,x); }); } else { arr.push(val); arr.forEach(function(x){ pp.append(name,x); }); } pp.delete('page'); commit(pp); }
  function pSet(name,val){ var pp=curParams(); pp.delete(name); if(val!==''&&val!=null) pp.set(name,val); pp.delete('page'); commit(pp); }
  function pFamily(name,vals){ var pp=curParams(); var names=vals.map(function(v){return v.value;}); var arr=pp.getAll(name); var anyOn=names.some(function(n){return arr.indexOf(n)>-1;}); pp.delete(name); if(anyOn){ arr=arr.filter(function(x){return names.indexOf(x)<0;}); } else { names.forEach(function(n){ if(arr.indexOf(n)<0) arr.push(n); }); } arr.forEach(function(x){ pp.append(name,x); }); pp.delete('page'); commit(pp); }
  // Toggle a whole SET of tag values at once (group -> its niche tags).

  function renderDrawer(){
    body.innerHTML='';
    var cf=findFilter('color');
    if(cf && cf.values.length>1){
      var fams={};
      cf.values.forEach(function(v){ var fam=famOf(v.label); (fams[fam]=fams[fam]||[]).push(v); });
      var dist=famDistinctCounts(baselinePc());
      var sec=grpEl('color','Color',true); var wrap=document.createElement('div'); wrap.className='cvn-fams';
      var colL=document.createElement('div'); colL.className='cvn-fam-col'; var colR=document.createElement('div'); colR.className='cvn-fam-col';
      wrap.appendChild(colL); wrap.appendChild(colR); var _ci=0;
      FAM_ORDER.forEach(function(fam){ var vs=fams[fam]; if(!vs) return;
        var selN=vs.filter(function(v){return pHas(cf.param,v.value);}).length;
        var allOn=selN===vs.length, someOn=selN>0;
        var sumShade=vs.reduce(function(a,v){return a+(v.count||0);},0);
        var maxShade=vs.reduce(function(a,v){return Math.max(a,v.count||0);},0);
        var famCt=dist?Math.min(sumShade,Math.max(dist[fam]||0,maxShade)):sumShade;
        var row=document.createElement('div'); row.className='cvn-fam'+(colorExpanded[fam]?' is-expanded':'');
        var head=document.createElement('div'); head.className='cvn-fam-head';
        var swb=document.createElement('button'); swb.type='button'; swb.className='cvn-fam-sw'+(allOn?' is-on':(someOn?' is-partial':'')); swb.style.background=famColor(fam); swb.setAttribute('aria-label',fam);
        var nm=document.createElement('button'); nm.type='button'; nm.className='cvn-fam-name'+(someOn?' is-on':''); nm.textContent=fam;
        var ct=document.createElement('span'); ct.className='cvn-fam-ct'+(someOn?' is-on':''); ct.textContent=famCt;
        var exp=document.createElement('button'); exp.type='button'; exp.className='cvn-fam-exp'; exp.setAttribute('aria-label','Show '+fam+' shades'); exp.innerHTML='&#9662;';
        swb.addEventListener('click',function(){ pFamily(cf.param,vs); });
        nm.addEventListener('click',function(){ pFamily(cf.param,vs); });
        exp.addEventListener('click',function(){ colorExpanded[fam]=!colorExpanded[fam]; row.classList.toggle('is-expanded'); });
        head.appendChild(swb); head.appendChild(nm); head.appendChild(ct); head.appendChild(exp);
        var sub=document.createElement('div'); sub.className='cvn-fam-sub';
        var vsSorted=vs.slice().sort(function(a,b){ return lightnessOf(hexOf(b.label,fam))-lightnessOf(hexOf(a.label,fam)); });
        vsSorted.forEach(function(v){
          var son=pHas(cf.param,v.value);
          var hx=hexOf(v.label,fam);
          var sq=document.createElement('button'); sq.type='button'; sq.className='cvn-csq'+(son?' is-on':'')+((!v.count&&!son)?' is-empty':''); sq.title=v.label+' ('+(v.count||0)+' product'+((v.count===1)?'':'s')+')';
          sq.innerHTML='<span class="cvn-csq-box" style="background:'+hx+'"></span><span class="cvn-csq-ct">'+(v.count||0)+'</span>';
          sq.addEventListener('click',function(){ pToggle(cf.param,v.value); });
          sub.appendChild(sq);
        });
        row.appendChild(head); row.appendChild(sub);
        (_ci%2===0?colL:colR).appendChild(row); _ci++;
      });
      sec.b.appendChild(wrap); body.appendChild(sec.g);
    }

    // Product Type — directly under Color. Greyed + demoted like Collections when a
    // selection elsewhere leaves a type with zero matching products (an active type stays on top).
    // Gift Card always renders LAST (Zeus): it is a utility product, not a piece, and the facet's
    // alphabetical order otherwise puts it first. Stable sort AFTER partAvail, so the available and
    // greyed tiers keep their internal order while Gift Card lands at the absolute bottom.
    var tf=findFilter('type');
    if(tf && tf.values.length>1){
      var giftLast=function(v){ return /gift\s*card/i.test(String(v.value))?1:0; };
      var sec3=grpEl('type','Product Type',true); var cw=document.createElement('div'); cw.className='cvn-checks';
      partAvail(tf.values.slice(), function(v){ return (v.count>0 || pHas(tf.param,v.value))?1:0; }).sort(function(a,b){ return giftLast(a)-giftLast(b); }).forEach(function(v){
        var act=pHas(tf.param,v.value);
        cw.appendChild(checkRow(tf.param,v.value,v.label,v.count,act,0,(!v.count && !act)));
      });
      sec3.b.appendChild(cw); body.appendChild(sec3.g);
    }

    var sf=findFilter('size');
    if(sf){
      var appVals=[], drinkVals=[];
      sf.values.forEach(function(v){ var lv=String(v.value).toLowerCase();
        if(/one\s*size|^os$|^one$/.test(lv)) return;
        if(lv.indexOf('oz')>-1) drinkVals.push(v); else appVals.push(v);
      });
      var sizeSection=function(key,title,vals){
        if(vals.length<2) return;
        var s=grpEl(key,title,true); var pw=document.createElement('div'); pw.className='cvn-pills';
        vals.slice().sort(function(a,b){return sizeRank(a.value)-sizeRank(b.value);}).forEach(function(v){
          var act=pHas(sf.param,v.value);
          var p=document.createElement('button'); p.type='button'; p.className='cvn-pill'+(act?' is-on':''); p.textContent=v.label;
          if(!v.count && !act) p.disabled=true;
          p.addEventListener('click',function(){ pToggle(sf.param,v.value); });
          pw.appendChild(p);
        });
        s.b.appendChild(pw); body.appendChild(s.g);
      };
      // Sizes are per product type: apparel Size for garments, Drinkware Size for mugs; totes have
      // NEITHER. Show a size section only when no type is chosen, or a relevant type is selected —
      // so choosing only Tote Bag(s) hides both, only Mug shows just Drinkware, only apparel shows
      // just Size.
      var _selTypes=tf?curParams().getAll(tf.param).map(function(x){return String(x).toLowerCase();}):[];
      var _noType=_selTypes.length===0;
      var _hasMug=_selTypes.some(function(t){return t.indexOf('mug')>-1;});
      var _hasApparel=_selTypes.some(function(t){return t.indexOf('mug')<0 && t.indexOf('tote')<0;});
      if(_noType || _hasApparel) sizeSection('size','Size',appVals);
      if(_noType || _hasMug) sizeSection('dsize','Drinkware Size',drinkVals);
    }

    var pf=findFilter('price');
    if(pf){
      var lo=Math.floor((DATA.priceMin!=null?DATA.priceMin:(pf.min||0)));
      var hi=Math.ceil((DATA.priceMax!=null?DATA.priceMax:(pf.rangeMax||pf.max||0)));
      if(hi>lo){
        var sec4=grpEl('price','Price',true);
        var _pp=curParams();
        var gte=parseInt(_pp.get('filter.v.price.gte'),10); if(isNaN(gte)) gte=lo; gte=Math.max(lo,Math.min(hi,gte));
        var lte=parseInt(_pp.get('filter.v.price.lte'),10); if(isNaN(lte)) lte=hi; lte=Math.max(lo,Math.min(hi,lte));
        if(gte>lte) gte=lte;
        var pw=document.createElement('div'); pw.className='cvn-price';
        pw.innerHTML=''
          +'<div class="cvn-range-vals"><span class="cvn-range-cur">$</span><input type="number" id="cvn-pmin" inputmode="numeric" min="'+lo+'" max="'+hi+'" step="1" value="'+gte+'"><span>&ndash;</span><span class="cvn-range-cur">$</span><input type="number" id="cvn-pmax" inputmode="numeric" min="'+lo+'" max="'+hi+'" step="1" value="'+lte+'"></div>'
          +'<div class="cvn-range"><div class="cvn-range-track"><div class="cvn-range-fill" id="cvn-rfill"></div></div>'
          +'<input type="range" id="cvn-rmin" min="'+lo+'" max="'+hi+'" step="1" value="'+gte+'" aria-label="Minimum price">'
          +'<input type="range" id="cvn-rmax" min="'+lo+'" max="'+hi+'" step="1" value="'+lte+'" aria-label="Maximum price"></div>';
        sec4.b.appendChild(pw); body.appendChild(sec4.g);
        var rmin=pw.querySelector('#cvn-rmin'), rmax=pw.querySelector('#cvn-rmax'),
            nmin=pw.querySelector('#cvn-pmin'), nmax=pw.querySelector('#cvn-pmax'), fill=pw.querySelector('#cvn-rfill');
        function paintP(a,b){ var pa=(a-lo)/(hi-lo)*100, pb=(b-lo)/(hi-lo)*100; fill.style.left=pa+'%'; fill.style.width=Math.max(0,pb-pa)+'%'; }
        function commitPrice(a,b){ var pp=curParams(); pp.delete('filter.v.price.gte'); pp.delete('filter.v.price.lte'); if(a>lo) pp.set('filter.v.price.gte',a); if(b<hi) pp.set('filter.v.price.lte',b); pp.delete('page'); commit(pp); }
        function onRange(){ var a=parseInt(rmin.value,10), b=parseInt(rmax.value,10); if(a>b){ if(this===rmin){ a=b; rmin.value=a; } else { b=a; rmax.value=b; } } nmin.value=a; nmax.value=b; paintP(a,b); }
        rmin.addEventListener('input',onRange); rmax.addEventListener('input',onRange);
        rmin.addEventListener('change',function(){ commitPrice(parseInt(rmin.value,10),parseInt(rmax.value,10)); });
        rmax.addEventListener('change',function(){ commitPrice(parseInt(rmin.value,10),parseInt(rmax.value,10)); });
        function onNum(elm){ var a=parseInt(nmin.value,10), b=parseInt(nmax.value,10); if(isNaN(a)) a=lo; if(isNaN(b)) b=hi; a=Math.max(lo,Math.min(hi,a)); b=Math.max(lo,Math.min(hi,b)); if(a>b){ if(elm===nmin) a=b; else b=a; } nmin.value=a; nmax.value=b; rmin.value=a; rmax.value=b; paintP(a,b); commitPrice(a,b); }
        nmin.addEventListener('change',function(){ onNum(nmin); }); nmax.addEventListener('change',function(){ onNum(nmax); });
        paintP(gte,lte);
      }
    }

    var collP=collParam(), vibeP=vibesParam();
    var TAX=window.CVN_TAXONOMY;
    if(TAX){
      var handle=String(DATA.handle||'').toLowerCase();
      // Which kind of collection page are we on? (handle matches a taxonomy slug). On a VIBE page we
      // hide the whole Vibes section; on a NICHE page the Collections section shows only that niche
      // (+ its micros) and the applicable Vibes.
      var pageNiche=null, pageVibe=null, pageGroup=null;
      for(var _i=0;_i<TAX.niches.length;_i++){ if(TAX.niches[_i].s===handle){ pageNiche=TAX.niches[_i]; break; } }
      for(var _j=0;_j<TAX.vibes.length;_j++){ if(TAX.vibes[_j].s===handle){ pageVibe=TAX.vibes[_j]; break; } }
      for(var _k=0;_k<TAX.groups.length;_k++){ if(TAX.groups[_k].s===handle){ pageGroup=TAX.groups[_k]; break; } }
      var aColl={}, aVibe={};
      curParams().getAll(collP).forEach(function(v){ aColl[String(v).toLowerCase()]=1; });
      curParams().getAll(vibeP).forEach(function(v){ aVibe[String(v).toLowerCase()]=1; });
      function aC(s){ return !!aColl[String(s).toLowerCase()]; }
      function aV(s){ return !!aVibe[String(s).toLowerCase()]; }
      var nbg={}; TAX.niches.forEach(function(n){ (nbg[n.g]=nbg[n.g]||[]).push(n); });
      var mbn={}; TAX.micros.forEach(function(m){ (mbn[m.ni]=mbn[m.ni]||[]).push(m); });

      // Build one expandable node (used for groups, niches-with-micros, vibe categories).
      function nodeEl(key,label,opts){
        var node=document.createElement('div'); node.className='cvn-node'+(opts.cls?(' '+opts.cls):'')+(opts.unavail?' cvn-unavail':'');
        var head=document.createElement('div'); head.className='cvn-node-head';
        var sub=document.createElement('div'); sub.className='cvn-node-sub';
        var car=document.createElement('button'); car.type='button'; car.className='cvn-node-caret'; car.innerHTML='&#9656;';
        function setOpen(o){ nodeOpen[key]=o; sub.style.display=o?'block':'none'; car.classList.toggle('is-open',o); }
        if(opts.checkbox){
          var cb=document.createElement('input'); cb.type='checkbox'; cb.checked=opts.checked; cb.indeterminate=!!opts.indeterminate;
          cb.addEventListener('change',opts.onCheck); head.appendChild(cb);
        }
        var nm=document.createElement('span'); nm.className='cvn-node-name'; nm.textContent=label;
        nm.addEventListener('click',function(){ setOpen(!nodeOpen[key]); });
        car.addEventListener('click',function(){ setOpen(!nodeOpen[key]); });
        head.appendChild(nm);
        head.appendChild(car);
        if(opts.count!=null){ var ctc=document.createElement('span'); ctc.className='cvn-ct'; ctc.textContent=opts.count; head.appendChild(ctc); }
        node.appendChild(head); node.appendChild(sub);
        setOpen(!!nodeOpen[key]);
        return {node:node, sub:sub};
      }

      // Two cross baselines (both reflect colour/size/type/price). PT_coll drops the COLLECTION
      // param (keeps the selected vibes) so vibes narrow the Collections counts; PT_vibe drops the
      // VIBES param so collection ticks narrow the Vibes counts. A 0 under the cross baseline
      // means the option is not applicable given the OTHER section's selection → EXCLUDE (hide) it.
      var PT_coll=stripBaseline(collP,'pt');
      var PT_vibe=stripBaseline(vibeP,'pt');
      var CNT_coll=tagCounts(PT_coll), CNT_vibe=tagCounts(PT_vibe);
      function cC(t){ return CNT_coll[String(t).toLowerCase()]||0; }
      function cV(t){ return CNT_vibe[String(t).toLowerCase()]||0; }
      function microsOf(n){ return (mbn[n.s]||[]).filter(function(m){ return m.s!==handle; }); }
      // Only VISIBLE (applicable) descendants show. A tick is ONE facet value now (a group tick no
      // longer expands to niche values), so tri-state is simply: own value on = full; a descendant
      // on = part. A micro under a selected niche is a subset → shown locked-checked.
      function visMicros(n){ return microsOf(n).filter(function(m){ return cC('micro:'+m.s)>0 || aC(m.s); }); }
      function nicheState(n){
        if(aC(n.s)) return 'full';
        return visMicros(n).some(function(m){ return aC(m.s); }) ? 'part' : 'none';
      }
      function nHasActive(n){ return nicheState(n)!=='none'; }
      function visNiches(g){ return (nbg[g.s]||[]).filter(function(n){ return n.s!==handle && (cC('niche:'+n.s)>0 || nHasActive(n)); }); }
      function groupState(g){
        if(aC(g.s)) return 'full';
        return visNiches(g).some(function(n){ return nicheState(n)!=='none'; }) ? 'part' : 'none';
      }
      function gHasActive(g){ return groupState(g)!=='none'; }
      var _collContent=false, sec5, cw2;
      if(pageNiche){
        // NICHE collection page: show the Collections section ONLY if this niche has applicable
        // micro-niches — then show just this niche + those micros. No micros → no Collections section.
        var pMicros=visMicros(pageNiche);
        if(pMicros.length){
      // ⚠ grpEl's third arg is OPEN, and `false` there means COLLAPSED (see grpEl: collapsed[key] =
      // (open === false)). All three Collections branches passed false, so the section a shopper on a
      // group or niche page most wants — the collections inside where they already are — arrived shut.
      // Opened by default on the pages where it is the point of the page: the Collections hub, a group
      // page (its niches) and a niche page (its micros). Elsewhere (Shop All, a product-type page) it
      // still starts closed, because there it is the whole nine-group tree and would bury the sidebar.
      // collapsed[key] still persists, so a shopper who shuts it keeps it shut.
          sec5=grpEl('coll','Collections',true); cw2=document.createElement('div'); cw2.className='cvn-checks cvn-tagtree';
          if(nodeOpen['n:'+pageNiche.s]===undefined) nodeOpen['n:'+pageNiche.s]=true;
          var pn=nodeEl('n:'+pageNiche.s, pageNiche.n, { cls:'cvn-node-niche', count:cC('niche:'+pageNiche.s) });
          pMicros.forEach(function(m){ pn.sub.appendChild(checkRow(collP,m.s,m.n,cC('micro:'+m.s),aC(m.s)||aC(pageNiche.s),0,false,aC(pageNiche.s))); });
          cw2.appendChild(pn.node); _collContent=true;
        }
      } else if(pageGroup){
        // GROUP collection page (e.g. /collections/sports-fitness): the useful narrowing is this
        // group's OWN niches, the same way a niche page offers its own micros.
        // ⚠ THE BUG THIS FIXES: without this branch a group page fell through to the general
        // list below, whose first filter is `g.s !== handle` — it drops the page's own group, and
        // every OTHER group then counts 0 products here, so every row was filtered out and the
        // section rendered as a bare header with nothing under it.
        var gNiches=visNiches(pageGroup);
        if(gNiches.length){
          sec5=grpEl('coll','Collections',true); cw2=document.createElement('div'); cw2.className='cvn-checks cvn-tagtree';
          gNiches.forEach(function(n){
            var micros=visMicros(n);
            if(micros.length){
              var nst=nicheState(n);
              var nn=nodeEl('n:'+n.s, n.n, { cls:'cvn-node-niche', checkbox:true, checked:nst==='full', indeterminate:nst==='part', count:cC('niche:'+n.s),
                onCheck:function(){ pToggle(collP,n.s); } });
              micros.forEach(function(m){ nn.sub.appendChild(checkRow(collP,m.s,m.n,cC('micro:'+m.s),aC(m.s)||aC(n.s),0,false,aC(n.s))); });
              cw2.appendChild(nn.node);
            } else {
              cw2.appendChild(checkRow(collP,n.s,n.n,cC('niche:'+n.s),aC(n.s),0,false));
            }
          });
        }
      } else {
        // the hub's own grid: the nine groups ARE what the page is for, so it opens; every other page
        // reaching this branch (Shop All, a product-type page) keeps it closed.
        var _collHubOpen = !!(DATA && DATA.handle && ',browse,'.indexOf(',' + DATA.handle + ',') > -1);
        sec5=grpEl('coll','Collections',_collHubOpen); cw2=document.createElement('div'); cw2.className='cvn-checks cvn-tagtree';
        availOnly(TAX.groups.filter(function(g){ return g.s!==handle && (nbg[g.s]||[]).some(function(n){ return n.s!==handle; }); }), function(g){ return cC('group:'+g.s); }, gHasActive).forEach(function(g){
          var niches=visNiches(g);
          var gs=groupState(g);
          var gn=nodeEl('g:'+g.s, g.n, { cls:'cvn-node-group', checkbox:true, checked:gs==='full', indeterminate:gs==='part', count:cC('group:'+g.s),
            onCheck:function(){ pToggle(collP,g.s); } });
          niches.forEach(function(n){
            var micros=visMicros(n);
            if(micros.length){
              var nst=nicheState(n);
              var nn=nodeEl('n:'+n.s, n.n, { cls:'cvn-node-niche', checkbox:true, checked:nst==='full'||aC(g.s), indeterminate:nst==='part'&&!aC(g.s), count:cC('niche:'+n.s),
                onCheck:function(){ pToggle(collP,n.s); } });
              micros.forEach(function(m){ nn.sub.appendChild(checkRow(collP,m.s,m.n,cC('micro:'+m.s),aC(m.s)||aC(n.s)||aC(g.s),0,false,aC(n.s)||aC(g.s))); });
              gn.sub.appendChild(nn.node);
            } else {
              gn.sub.appendChild(checkRow(collP,n.s,n.n,cC('niche:'+n.s),aC(n.s)||aC(g.s),0,false,aC(g.s)));
            }
          });
          cw2.appendChild(gn.node);
        });
      }
      // ⚠ Was an unconditional `_collContent = true` on the general branch, so a Collections
      // section whose every row had been filtered out still rendered — a header with an empty
      // body. Ask the tree what it actually holds instead of trusting the branch.
      if(cw2 && cw2.children.length) _collContent=true;
      if(_collContent && sec5){ sec5.b.appendChild(cw2); body.appendChild(sec5.g); }

      // Hide the whole Vibes section when we're already ON a vibe collection page.
      if(!pageVibe){
        var vbc={}; TAX.vibes.forEach(function(v){ (vbc[v.c]=vbc[v.c]||[]).push(v); });
        // Vibe-category count = DISTINCT products (a product can hold several vibes, so summing would
        // double-count). Over PT_vibe so selected niches narrow it.
        var catDistinct=function(vc,pt){ var set={}; (vbc[vc.s]||[]).forEach(function(v){ set['vibe:'+v.s]=1; });
          var n=0; (pt||[]).forEach(function(tags){ for(var i=0;i<tags.length;i++){ if(set[String(tags[i]).toLowerCase()]){ n++; break; } } }); return n; };
        // On the Vibes hub the vibe categories ARE what the page is for, so that section opens;
        // Collections stays shut there (it is the whole nine-group tree). Everywhere else Vibes
        // keeps its old closed default. collapsed[key] still persists once the shopper decides.
        var _vibesHubOpen = !!(DATA && DATA.handle && ',vibes,'.indexOf(',' + DATA.handle + ',') > -1);
        var sec6=grpEl('vibes','Vibes',_vibesHubOpen); var vw=document.createElement('div'); vw.className='cvn-checks cvn-tagtree';
        availOnly(TAX.vibecats.filter(function(vc){ return (vbc[vc.s]||[]).some(function(v){ return v.s!==handle; }); }), function(vc){ return catDistinct(vc,PT_vibe); }, function(vc){ return (vbc[vc.s]||[]).some(function(v){ return aV(v.s); }); }).forEach(function(vc){
          var list=(vbc[vc.s]||[]).filter(function(v){ return v.s!==handle; });
          var vn=nodeEl('vc:'+vc.s, vc.n, { cls:'cvn-node-group', count:catDistinct(vc,PT_vibe) });
          availOnly(list, function(v){ return cV('vibe:'+v.s); }, function(v){ return aV(v.s); }).forEach(function(v){ vn.sub.appendChild(checkRow(vibeP,v.s,v.n,cV('vibe:'+v.s),aV(v.s),0,false)); });
          vw.appendChild(vn.node);
        });
        sec6.b.appendChild(vw); body.appendChild(sec6.g);
      }
    }
  }

  function checkRow(param,val,label,count,active,indent,unavail,locked){
    var l=document.createElement('label'); l.className='cvn-check'+(indent?' cvn-sub':'')+(unavail?' cvn-unavail':'');
    if(indent===2) l.style.marginLeft='44px';
    if(locked) l.style.cursor='default';
    var cb=document.createElement('input'); cb.type='checkbox'; cb.checked=!!active;
    var t=document.createElement('span'); t.textContent=label;
    var c=document.createElement('span'); c.className='cvn-ct'; c.textContent=count;
    // `locked` = this micro's parent niche is selected, so the micro is necessarily included
    // (its products are a subset of the niche's). Show it checked and ignore clicks.
    cb.addEventListener('change',function(){ if(locked){ cb.checked=true; return; } pToggle(param,val); });
    l.appendChild(cb); l.appendChild(t); l.appendChild(c); return l;
  }

  // How many browse filters are active. A slug that is covered by a selected ANCESTOR in the
  // same facet (micro under its selected niche, niche/micro under its selected group) is a
  // subset of the selection and folds into it.
  function browseFilterCount(cv,vv){
    var TX=window.CVN_TAXONOMY; var n=vv.length;
    if(!TX) return n+cv.length;
    var gset={}, nich={}, micr={};
    TX.groups.forEach(function(g){ gset[g.s]=1; });
    TX.niches.forEach(function(nn){ nich[nn.s]=nn.g; });
    TX.micros.forEach(function(m){ micr[m.s]=m.ni; });
    var has={}; cv.forEach(function(s){ has[s]=1; });
    cv.forEach(function(s){
      if(micr[s]!==undefined){ var pn=micr[s]; if(has[pn]||has[nich[pn]]) return; n++; return; }
      if(nich[s]!==undefined){ if(has[nich[s]]) return; n++; return; }
      n++;   // a group, or an unknown slug — counts as itself
    });
    return n;
  }

  function committedCount(){
    var p=curParams(), n=0;
    var cf=findFilter('color'); if(cf){ var fams={}; p.getAll(cf.param).forEach(function(v){ fams[famOf(v)]=1; }); n+=Object.keys(fams).length; }
    var sf=findFilter('size'); if(sf){ p.getAll(sf.param).forEach(function(v){ if(!/one\s*size|^os$|^one$/.test(String(v).toLowerCase())) n++; }); }
    var tf=findFilter('type'); if(tf){ n+=p.getAll(tf.param).length; }
    n+=browseFilterCount(p.getAll(collParam()).map(function(s){return String(s).toLowerCase();}),
                         p.getAll(vibesParam()).map(function(s){return String(s).toLowerCase();}));
    if(p.get('filter.v.price.gte')||p.get('filter.v.price.lte')) n++;
    return n;
  }

  // Custom sort dropdown (native <select> can't do full-pill click / no focus box / styled rounded list).
  function applySort(v){ var pp=curParams(); pp.delete('sort_by'); if(v) pp.set('sort_by',v); pp.delete('page'); commit(pp); }
  function renderSort(){
    var pill=document.querySelector('.cvn-fsort'); if(!pill) return;
    var opts=DATA.sortOptions||[], cur=DATA.sortBy;
    var val=pill.querySelector('.cvn-fsort-val'), menu=pill.querySelector('.cvn-fsort-menu');
    if(!val){
      if(sortSel) sortSel.style.display='none';   // hide the native select; the pill drives sorting now
      val=document.createElement('span'); val.className='cvn-fsort-val'; pill.appendChild(val);
      var car=document.createElement('span'); car.className='cvn-fsort-caret'; car.setAttribute('aria-hidden','true');
      car.innerHTML='<svg viewBox="0 0 20 20" width="12" height="12"><path d="M5 8l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      pill.appendChild(car);
      menu=document.createElement('div'); menu.className='cvn-fsort-menu'; menu.setAttribute('role','listbox'); pill.appendChild(menu);
      pill.setAttribute('role','button'); pill.setAttribute('tabindex','0'); pill.setAttribute('aria-haspopup','listbox');
      pill.addEventListener('click', function(e){
        var o=e.target.closest('.cvn-fsort-opt');
        if(o){ e.stopPropagation(); applySort(o.getAttribute('data-v')); pill.classList.remove('is-open'); return; }
        if(e.target.closest('.cvn-fsort-menu')){ e.stopPropagation(); return; }
        e.stopPropagation(); var _dp=document.querySelector('.cvn-fdens-pop'); if(_dp){ _dp.classList.remove('is-open'); var _db=document.querySelector('.cvn-fdens-btn'); if(_db) _db.setAttribute('aria-expanded','false'); } pill.classList.toggle('is-open');
      });
      pill.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pill.classList.toggle('is-open'); } else if(e.key==='Escape'){ pill.classList.remove('is-open'); } });
    }
    var curName=''; for(var i=0;i<opts.length;i++){ if(opts[i].v===cur){ curName=opts[i].n; break; } }
    if(!curName && opts.length) curName=opts[0].n;
    val.textContent=curName;
    menu.innerHTML='';
    opts.forEach(function(o){ var b=document.createElement('button'); b.type='button'; b.className='cvn-fsort-opt'+(o.v===cur?' is-on':''); b.setAttribute('data-v',o.v); b.setAttribute('role','option'); b.textContent=o.n; menu.appendChild(b); });
    document.documentElement.classList.add('cvn-sort-ready'); // reveal the sort/count now that they're positioned + labelled (avoids the "Sort" flash)
  }
  // Page-aware noun for the count. Product-type collections show their type; everything else (niche,
  // vibe, generic/all collections) says "products". Order matters: "sweatshirt" contains "tshirt", so
  // crew/sweatshirt is tested before t-shirt.
  function countNoun(){
    var h=(DATA.handle||'').toLowerCase();
    if(/hoodie/.test(h)) return 'hoodies';
    if(/crew|sweatshirt/.test(h)) return 'crewnecks';
    if(/t-?shirt|tee/.test(h)) return 't-shirts';
    if(/tote/.test(h)) return 'tote bags';
    if(/mug|drinkware/.test(h)) return 'mugs';
    return 'products';
  }
  /* ===== PRODUCT-TYPE PILLS — the piece question, answered in the bar =====
     A row of pills under the bar (Shop All only; sections/cvn-type-pills supplies the house names and
     the Shop-by-Type order, and its presence is what turns this on).

     ⚠ THE STATE MODEL IS "no restriction", NOT "five things ticked". While nothing is filtered every
     pill reads ON, because the shopper IS seeing all five pieces — a row of empty checkboxes would
     say the opposite of what the page is showing. So the first click does the thing people actually
     come to do (show me only mugs) instead of the thing the ticked-box reading implies (show me
     everything except mugs, which is not a shopping intent):
         nothing filtered  + click X   -> only X          (one click for the common case)
         X selected        + click Y   -> X and Y         (ordinary multi-select from there on)
         X,Y selected      + click X   -> Y
         X selected        + click X   -> nothing filtered (all pills read ON again)
     Selecting every type collapses to the unfiltered URL, so "all on" has exactly one address.
     Product type is then NOT repeated as an applied chip (renderChips skips it while the pills are
     up): one facet, one control, or the two disagree the moment either is used. */
  /* ===== PRODUCT-TYPE PILLS (Shop All) =====
     There is no pill code, no pill markup and no pill styling anywhere: the page simply ARRIVES with
     the product-type filter applied (the replaceState at the end of initFilter), and from there the
     ordinary applied-filter machinery does all of it — renderChips builds the chips, restChips places
     them, "Clear all" shows because a filter is committed, the drawer ticks its own boxes off the URL.
     This function only answers WHETHER this page is one of those pages; sections/cvn-type-pills is
     the switch that says so. Earlier versions drew a lookalike row and had to keep it in step with the
     real filter by hand — every one of those seams is gone because there is only one state now. */
  function typePillsOn(){
    var el=document.getElementById('cvn-ftype-pills'); if(!el) return false;   // the section decides WHICH pages
    var tf=findFilter('type');
    return !!(tf && tf.values && tf.values.length>1);
  }

  function renderBar(){
    renderSort();
    renderChips();
    var n=committedCount();
    if(_bar) _bar.classList.toggle('cvn-has-active', n>0); // phone: make the bar sticky while filters are active
    var _ap=document.querySelector('.cvn-fapplied'); if(_ap) _ap.style.display=(chips&&chips.children.length)?'':'none'; // phone "Applied" section only when filters active
    var _apb=document.querySelector('.cvn-fapplied-badge'); if(_apb) _apb.textContent=n;   // count shown when the Applied section is collapsed
    updateShowing();   // wide sidebar "Showing N (of M) products" header
    badge.textContent=n; badge.hidden=n===0;
    clearBtn.hidden=n===0;
    if(_sideClear) _sideClear.hidden=n===0;
    var c=DATA.count, _noun=countNoun();
    if(typeof c==='number'){ var _cn=(_noun==='products'&&c===1)?'product':_noun; results.textContent=c+' '+_cn; }
    else results.textContent='';
    // Drawer header count: "N out of M noun" when filtered, else "M noun".
    var _dc=document.querySelector('.cvn-fdrawer-count');
    if(_dc){ var _tot=(typeof DATA.allCount==='number')?DATA.allCount:c;
      if(typeof c!=='number') _dc.textContent='';
      else if(n>0 && _tot!==c) _dc.innerHTML='<strong>'+c+'</strong> of '+_tot+' '+_noun;
      else { var _one=(_noun==='products'&&_tot===1); _dc.innerHTML='<strong>'+_tot+'</strong> '+(_one?'product':_noun); }
    }
    _fitBar();   // PHONE ONLY: shrink the bar row to fit when Filters + count + density + Sort overflow the screen
  }

  // the applied-chip cross — ONE definition, so a type pill and a drawer chip cannot drift apart
  function chipX(){ var x=document.createElement('span'); x.className='cvn-fchip-x'; x.innerHTML='<svg viewBox="0 0 20 20" width="11" height="11" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'; return x; }
  function renderChips(){
    chips.innerHTML='';
    var made=[]; var cp=curParams(); var TAX=window.CVN_TAXONOMY;
    var collP=collParam(), vibeP=vibesParam();
    var collVals=cp.getAll(collP), vibeVals=cp.getAll(vibeP);
    // Pill order = filter-menu order, but Product Type first:
    // Type · Color · Size · Drinkware · Price · Collections · Vibes.

    // 1) PRODUCT TYPE — one pill each. On Shop All these are the five the page arrives with (see the
    //    replaceState in initFilter); nothing here knows or cares that they were not typed by hand.
    var tf=findFilter('type');
    if(tf) cp.getAll(tf.param).forEach(function(val){ var v=tf.values.filter(function(x){return x.value===val;})[0]; made.push({param:tf.param, values:[val], label:(v?v.label:val)}); });

    // 2) COLOR — one "Color:" pill of swatches (family colour if the whole family is picked, else each shade's hex)
    var cf=findFilter('color');
    if(cf){ var selC=cp.getAll(cf.param);
      if(selC.length){
        var byFam={}; cf.values.forEach(function(v){ var f=famOf(v.label); (byFam[f]=byFam[f]||{sel:[],all:0}); byFam[f].all++; if(selC.indexOf(v.value)>-1) byFam[f].sel.push(v); });
        var sw=[]; var order=FAM_ORDER.concat(Object.keys(byFam).filter(function(f){return FAM_ORDER.indexOf(f)<0;}));
        order.forEach(function(f){ var g=byFam[f]; if(!g||!g.sel.length) return; if(g.sel.length>=g.all){ sw.push(famColor(f)); } else { g.sel.forEach(function(v){ sw.push(hexOf(v.label,f)); }); } });
        made.push({param:cf.param, values:selC, label:'', swatches:sw, colorChip:true});   // no "Color:" label; fitColorSwatches() trims swatches to fit and adds "+n"
      }
    }

    // 3+4) SIZES — apparel ("Size: S, M, L") + drinkware ("11 oz, 15 oz")
    var sf=findFilter('size');
    if(sf){ var app=[], drk=[];
      cp.getAll(sf.param).forEach(function(val){ var v=sf.values.filter(function(x){return x.value===val;})[0]; var lbl=v?v.label:val; if(/oz/i.test(val)) drk.push({v:val,l:lbl}); else if(!/one\s*size|^os$|^one$/i.test(val)) app.push({v:val,l:lbl}); });
      app.sort(function(a,b){return sizeRank(a.v)-sizeRank(b.v);}); drk.sort(function(a,b){return sizeRank(a.v)-sizeRank(b.v);});
      if(app.length) made.push({param:sf.param, values:app.map(function(x){return x.v;}), label:'Size: '+app.map(function(x){return x.l;}).join(', ')});
      if(drk.length) made.push({param:sf.param, values:drk.map(function(x){return x.v;}), label:drk.map(function(x){return x.l;}).join(', ')});
    }

    // 5) PRICE — min floors to the lowest product price (never $0)
    var gte=cp.get('filter.v.price.gte'), lte=cp.get('filter.v.price.lte');
    if(gte||lte){ var lo=Math.floor(DATA.priceMin!=null?DATA.priceMin:0), hi=Math.ceil(DATA.priceMax!=null?DATA.priceMax:0);
      made.push({price:true, label:'$'+(gte||lo)+' - $'+(lte||hi)}); }

    // 6) COLLECTIONS — one pill. Every applied value names itself (a group tick IS one value now,
    // so there is nothing to collapse); a niche/micro covered by a selected ANCESTOR value folds
    // into it (subset). Order = groups, then niches, then micros; 5 names then +n more.
    if(TAX && collVals.length){
      var gBy={}; TAX.groups.forEach(function(g){ gBy[g.s]=g; });
      var nBy={}; TAX.niches.forEach(function(n){ nBy[n.s]=n; });
      var mBy={}; TAX.micros.forEach(function(m){ mBy[m.s]=m; });
      var cset={}; collVals.forEach(function(v){ cset[String(v).toLowerCase()]=1; });
      var cnames=[], cvals=[];
      collVals.forEach(function(v){ var s=String(v).toLowerCase(); if(gBy[s]){ cnames.push(gBy[s].n); cvals.push(v); } });
      collVals.forEach(function(v){ var s=String(v).toLowerCase(); var n=nBy[s]; if(!n) return; cvals.push(v); if(!cset[n.g]) cnames.push(n.n); });
      collVals.forEach(function(v){ var s=String(v).toLowerCase(); var m=mBy[s]; if(!m) return; cvals.push(v); var pg=(nBy[m.ni]||{}).g; if(!cset[m.ni] && !(pg&&cset[pg])) cnames.push(m.n); });
      collVals.forEach(function(v){ var s=String(v).toLowerCase(); if(!gBy[s]&&!nBy[s]&&!mBy[s]){ cnames.push(tc(s)); cvals.push(v); } });
      if(cnames.length){ var cs=cnames.slice(0,5), ce=cnames.length-cs.length; made.push({param:collP, values:cvals, label:cs.join(', ')+(ce>0?' +'+ce+' more':'')}); }
    }

    // 7) VIBES — a pill per category (Moods / Styles / Subjects), 3 names then +n more
    if(TAX && vibeVals.length){
      var vBy={}; TAX.vibes.forEach(function(v){ vBy[v.s]=v; });
      var byCat={}, vOther=[];
      vibeVals.forEach(function(t){ var v=vBy[String(t).toLowerCase()]; if(v){ (byCat[v.c]=byCat[v.c]||[]).push({n:v.n,t:t}); } else { vOther.push(t); } });
      TAX.vibecats.forEach(function(vc){ var arr=byCat[vc.s]; if(!arr||!arr.length) return; var nm=arr.map(function(x){return x.n;}); var s=nm.slice(0,3), e=nm.length-s.length;
        made.push({param:vibeP, values:arr.map(function(x){return x.t;}), label:vc.n+': '+s.join(', ')+(e>0?' +'+e+' more':'')}); });
      if(vOther.length) made.push({param:vibeP, values:vOther, label:vOther.map(tc).join(', ')});
    }

    // "Clear all" as the FIRST pill (both wide sidebar + drawer modes) whenever any filter is active.
    if(made.length){ var _cab=document.createElement('button'); _cab.type='button'; _cab.className='cvn-fchip cvn-fchip-clear'; _cab.textContent='Clear all'; _cab.addEventListener('click',clearAll); chips.appendChild(_cab); }
    made.forEach(function(m){ var b=document.createElement('button'); b.type='button'; b.className='cvn-fchip'+(m.colorChip?' cvn-fchip-color':'');
      if(m.label){ var lab=document.createElement('span'); lab.textContent=m.label; b.appendChild(lab); }
      if(m.swatches){ m.swatches.forEach(function(hx){ var s=document.createElement('span'); s.className='cvn-chip-sw'; s.style.background=hx; b.appendChild(s); }); }
      b.appendChild(chipX());
      b.addEventListener('click',function(){ var pp=curParams();
        if(m.price){ pp.delete('filter.v.price.gte'); pp.delete('filter.v.price.lte'); }
        else { var arr=pp.getAll(m.param); pp.delete(m.param); arr.forEach(function(x){ if(m.values.indexOf(x)<0) pp.append(m.param,x); }); }
        pp.delete('page'); commit(pp);
      });
      chips.appendChild(b); });
    fitColorSwatches();
  }
  // The color pill sits on its own full-width line (in the drawer's Applied section); if its swatches don't
  // fit that line, hide the overflow from the end and append a "+n". Iterative measure so it's exact at any width.
  function fitColorSwatches(){
    var chip=chips.querySelector('.cvn-fchip-color'); if(!chip) return;
    var old=chip.querySelector('.cvn-chip-more'); if(old) old.parentNode.removeChild(old);
    var sws=[].slice.call(chip.querySelectorAll('.cvn-chip-sw')); if(!sws.length) return;
    sws.forEach(function(s){ s.style.display=''; });
    if(chip.scrollWidth<=chip.clientWidth+1) return;   // everything fits — no "+n"
    var x=chip.querySelector('.cvn-fchip-x');
    var more=document.createElement('span'); more.className='cvn-chip-more';
    if(x) chip.insertBefore(more,x); else chip.appendChild(more);
    var hidden=0;
    for(var i=sws.length-1;i>=1;i--){ hidden++; sws[i].style.display='none'; more.textContent='+'+hidden;
      if(chip.scrollWidth<=chip.clientWidth+1) break; }
  }
  function taxLabel(t){ var raw=String(t).toLowerCase(); var TAX=window.CVN_TAXONOMY; var slug=raw.split(':').pop(); var kind=raw.split(':')[0];
    if(TAX){ var arr=kind==='niche'?TAX.niches:kind==='group'?TAX.groups:kind==='micro'?TAX.micros:kind==='vibe'?TAX.vibes:null;
      if(arr){ for(var i=0;i<arr.length;i++){ if(arr[i].s===slug) return arr[i].n; } } }
    return tc(slug);
  }

  var applyTimer=null;
  function commit(params){
    history.pushState({cvn:1},'',urlFor(params));
    renderBar();
    if(panelVisible()){ var _st=body.scrollTop; renderDrawer(); body.scrollTop=_st; }
    var cg=document.getElementById('product-grid'); if(cg) cg.classList.add('cvn-loading');
    clearTimeout(applyTimer);
    applyTimer=setTimeout(function(){ apply(location.pathname+location.search,false); }, 380);
  }
  function apply(url,push){
    var cur=document.getElementById('product-grid'); if(cur) cur.classList.add('cvn-loading');
    var fq; try{ fq=fetchUrl(new URLSearchParams(url.split('?')[1]||'')); }catch(e){ fq=url; } // augment size for the grid fetch; address bar stays raw
    fetch(fq).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var ng=doc.getElementById('product-grid'); var cg=document.getElementById('product-grid');
      if(ng&&cg){ cg.innerHTML=ng.innerHTML; cg.className=ng.className;
        // Strip Dawn's scroll-reveal so filtered products appear INSTANTLY instead of re-playing
        // the slide-in (opacity:0 + translateY) "jump/nudge" on every apply. Removing the classes
        // alone leaves the items stuck hidden (the reveal observer never runs), so also force them
        // visible inline (inline wins; the hide rule is not !important).
        cg.classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen');
        var sr=cg.querySelectorAll('.scroll-trigger, .animate--slide-in'); for(var i=0;i<sr.length;i++){ sr[i].classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen'); }
        var gi=cg.querySelectorAll('.grid__item'); for(var i=0;i<gi.length;i++){ gi[i].style.opacity='1'; gi[i].style.transform='none'; gi[i].style.animation='none'; } }
      // Pagination: DEDUPE then place. Remove every existing pagination first — a race between two
      // applies (e.g. clear-all) could otherwise leave two, and the extra one auto-places into the narrow
      // sidebar grid column where its page numbers wrap VERTICALLY. Then insert the fetched one (if any)
      // right after the grid, as a direct child of the collection, so the CSS puts it in the wide column.
      var np=doc.querySelector('.collection .pagination-wrapper')||doc.querySelector('nav.pagination');
      var _coll=document.querySelector('.collection.page-width')||document.querySelector('.collection');
      // Dawn only emits component-pagination.css when a page has >1 page, so a view first loaded with a
      // single-page filter never loaded it — and the pager we then insert renders as an UNSTYLED vertical
      // list (.pagination__list stays display:block). Copy the stylesheet link out of the fetched doc into
      // <head> if it isn't already present, so the inserted pager is styled.
      if(np){ var _pl=doc.querySelector('link[href*="pagination"]'); if(_pl && !document.querySelector('link[href*="pagination"]')){ try{ document.head.appendChild(_pl.cloneNode(true)); }catch(e){} } }
      Array.prototype.forEach.call(document.querySelectorAll('.collection .pagination-wrapper'),function(e){ e.remove(); });
      Array.prototype.forEach.call(document.querySelectorAll('.collection nav.pagination'),function(e){ e.remove(); });
      if(np&&_coll){ var _g=document.getElementById('product-grid'); var _ins=np.cloneNode(true);
        if(_g&&_g.parentNode===_coll&&_g.nextSibling) _coll.insertBefore(_ins,_g.nextSibling); else _coll.appendChild(_ins); }
      var ndW=doc.querySelector('.cvn-cc-data-wrap'), odW=document.querySelector('.cvn-cc-data-wrap');
      if(ndW&&odW){ try{ odW.replaceWith(document.importNode(ndW,true)); }catch(e){} }
      var nd=doc.getElementById('cvn-filter-data'); if(nd){ try{ DATA=JSON.parse(nd.textContent); }catch(e){} }
      if(push) history.pushState({cvn:1},'',url);
      renderBar();
      if(panelVisible()){ var _st=body.scrollTop; renderDrawer(); body.scrollTop=_st; }
      var g2=document.getElementById('product-grid'); if(g2) g2.classList.remove('cvn-loading');
      // The re-rendered grid arrives with the SERVER className (cg.className=ng.className above), which has
      // no cvn-dens/cvn-cN — so the chosen columns-per-row are lost on every apply/clear. Re-apply the saved
      // density (reads the cookie) so the grid keeps the user's selection through filter changes.
      if(document.querySelector('.cvn-fdensity')) _densRender();
      try{ document.dispatchEvent(new Event('shopify:section:load')); }catch(e){}
      refineCards(); scheduleRefine();
      try{ window.dispatchEvent(new CustomEvent('cvn:grid-updated')); }catch(e){}
    }).catch(function(){ var gg=document.getElementById('product-grid'); if(gg) gg.classList.remove('cvn-loading'); });
  }

  function activeNamesFor(kind){ var f=findFilter(kind); if(!f) return []; return curParams().getAll(f.param).map(function(x){return String(x).toLowerCase();}); }
  function refineCards(){
    var colors=activeNamesFor('color'), sizes=activeNamesFor('size');
    var cards=document.querySelectorAll('#product-grid .card-wrapper');
    for(var i=0;i<cards.length;i++){
      var wrap=cards[i].querySelector('.cvn-cc-wrap'); if(!wrap) continue;
      var isSize=!!wrap.querySelector('.cvn-sz');
      var sel=isSize?sizes:colors;
      var chipsEls=wrap.querySelectorAll('.cvn-cc');
      if(!sel.length){ for(var k=0;k<chipsEls.length;k++){ chipsEls[k].style.display=''; } continue; }
      var firstVisible=null, anyVisibleOn=false;
      for(var j=0;j<chipsEls.length;j++){ var ch=chipsEls[j];
        var nm=((ch.__c&&ch.__c.name)||ch.textContent||'').toLowerCase();
        var match=sel.indexOf(nm)>-1;
        ch.style.display=match?'':'none';
        if(match){ if(!firstVisible) firstVisible=ch; if(ch.classList.contains('is-on')) anyVisibleOn=true; }
      }
      // Auto-pick the first matching colour ONLY when no matching colour is currently selected — so the
      // card shows a colour that fits the filter, but the shopper's own pick among the matching colours
      // (e.g. Cardinal, not the first swatch Maroon) is never overridden by a later refine pass — which
      // was silently reverting the card + its variant link back to the first colour.
      if(firstVisible && !anyVisibleOn) firstVisible.click();
    }
  }
  var refineTs=[];
  function scheduleRefine(){ refineTs.forEach(clearTimeout); refineTs=[80,300,700].map(function(ms){ return setTimeout(refineCards,ms); }); }

  function headerBottom(){ var b=0; document.querySelectorAll('.header-wrapper, .section-header, sticky-header, .announcement-bar-section, .utility-bar').forEach(function(e){ var r=e.getBoundingClientRect(); if(r.top<80 && r.bottom>b) b=r.bottom; }); return Math.max(0,Math.round(b)); }
  // Full-viewport drawer: the scrim covers the ENTIRE viewport (header, logo, whitespace, sides), so a
  // click anywhere outside the panel closes it — not just the content below the header. (Was offset to
  // headerBottom(), which left the header band uncovered and un-closable.)
  function openD(){ if(isWide()) return; renderDrawer(); chipsToActive(body.parentNode); renderBar(); drawer.style.top='0px'; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.getElementById('cvn-fopen').setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; document.body.classList.add('cvn-filter-open'); requestAnimationFrame(fitColorSwatches); }
  function closeD(){ restChips(); renderBar(); drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.getElementById('cvn-fopen').setAttribute('aria-expanded','false'); document.body.style.overflow=''; document.body.classList.remove('cvn-filter-open'); setTimeout(function(){ if(!drawer.classList.contains('is-open')) drawer.style.top=''; },320); }
  function isWide(){ return window.matchMedia('(min-width:1649px)').matches; }
  function panelVisible(){ return drawer.classList.contains('is-open') || document.body.classList.contains('cvn-wide-filter'); }
  // Drop every filter.* (and page), but KEEP non-filter params like view=grid and sort_by. Rebuilding
  // a bare param set here silently dropped view=grid, so the clear fetched the non-grid template (no
  // #cvn-filter-data) and the drawer/counts never refreshed until a manual reload restored view=grid.
  function clearAll(){ var cp=curParams(); var np=new URLSearchParams(); cp.forEach(function(v,k){ if(k.indexOf('filter.')!==0 && k!=='page') np.append(k,v); }); commit(np); }
  // Wide desktop: relocate #cvn-fbody into a persistent left sidebar beside the grid; narrow: move it
  // back into the off-canvas drawer. Toggled on load + resize.
  var _sideEl=null, _sideClear=null, _bodyHome=body.parentNode, _bodyNext=body.nextSibling;
  function btnLabel(t){ var l=document.querySelector('#cvn-fopen span:not(.cvn-fbtn-badge)'); if(l) l.textContent=t; }
  // ---- active-pill placement -------------------------------------------------------------------------
  function _buildApplied(){
    var ap=document.createElement('div'); ap.className='cvn-fapplied';
    var h=document.createElement('div'); h.className='cvn-fapplied-head';
    var ht=document.createElement('span'); ht.className='cvn-fapplied-title'; ht.textContent='Active'; h.appendChild(ht);
    var hb=document.createElement('span'); hb.className='cvn-fapplied-badge'; h.appendChild(hb);
    var hc=document.createElement('span'); hc.className='cvn-fapplied-caret'; hc.setAttribute('aria-hidden','true');
    hc.innerHTML='<svg viewBox="0 0 20 20" width="13" height="13"><path d="M5 8l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'; h.appendChild(hc);
    h.addEventListener('click', function(){ ap.classList.toggle('is-collapsed'); });
    ap.appendChild(h); return ap;
  }
  function chipsToActive(panel){ if(!panel||!chips) return; var ap=panel.querySelector('.cvn-fapplied')||_buildApplied(); if(chips.parentNode!==ap) ap.appendChild(chips); if(ap.parentNode!==panel||ap.nextSibling!==body) panel.insertBefore(ap, body); }
  function chipsToBar(){ if(!chips) return; var cr=document.querySelector('.cvn-fbar-row'), co=document.getElementById('cvn-fopen'); if(cr&&chips.parentNode!==cr) cr.insertBefore(chips, co?co.nextSibling:cr.firstChild); var aps=document.querySelectorAll('.cvn-fapplied'); for(var i=0;i<aps.length;i++){ if(aps[i].parentNode) aps[i].parentNode.removeChild(aps[i]); } }
  // Resting placement: PHONE → drawer "Active" section; MID-DESKTOP + WIDE → the bar. On mid-desktop, openD
  // moves the bar pills into the drawer's Active section while it's open (so you can see what's filtered),
  // and closeD calls this to move them back to the bar.
  function restChips(){ if(!chips) return; if(window.matchMedia('(max-width:749px)').matches) chipsToActive(body.parentNode); else chipsToBar(); }
  // Wide sidebar "Showing N products" / "Showing N of M products" header (created in applyLayout's wide branch).
  function updateShowing(){ var el=document.querySelector('.cvn-showing'); if(!el) return;
    var noun=countNoun(), c=DATA.count, tot=(typeof DATA.allCount==='number')?DATA.allCount:c, n=committedCount();
    if(typeof c!=='number'){ el.textContent=''; return; }
    var txt = (n>0 && tot!==c) ? ('Showing <strong>'+c+'</strong> of '+tot+' '+noun) : ('<strong>'+tot+'</strong> '+noun);
    el.innerHTML = '<span>'+txt+'</span>';   // single span so the flex container doesn't trim the spaces around the bold number
  }
  function applyLayout(){
    var coll=document.querySelector('.collection.page-width'); if(!coll) return;
    var h=document.documentElement;    // CSS decides the wide layout by media query; JS only flips html.cvn-side-off (the "hide sidebar" toggle)
    if(isWide()){
      if(!_sideEl){ _sideEl=coll.querySelector('.cvn-side');    // adopt one if a prior layout left it
        if(!_sideEl){ _sideEl=document.createElement('div'); _sideEl.className='cvn-side'; } }
          // No sidebar title/Clear-all text — the "Filters" heading was removed and Clear all is now the
          // first active-filter pill in the bar (see renderChips). Sections sit at the grid's top level.
      if(body.parentNode!==_sideEl) _sideEl.appendChild(body);
      if(_sideEl.parentNode!==coll) coll.insertBefore(_sideEl, coll.firstChild);
      var _sh=_sideEl.querySelector('.cvn-showing'); if(!_sh){ _sh=document.createElement('div'); _sh.className='cvn-showing'; }   // "Showing N (of M) products" at the sidebar top
      if(_sh.parentNode!==_sideEl || _sh.nextSibling!==body) _sideEl.insertBefore(_sh, body);
      if(drawer.classList.contains('is-open')) closeD();
      if(_sideHidden){
        h.classList.add('cvn-side-off'); _sideEl.style.display='none'; document.body.classList.remove('cvn-wide-filter');
        btnLabel('Show Filters');
      } else {
        h.classList.remove('cvn-side-off'); _sideEl.style.display=''; document.body.classList.add('cvn-wide-filter');
        btnLabel('Hide Filters'); renderDrawer();
      }
    } else {
      h.classList.remove('cvn-side-off'); document.body.classList.remove('cvn-wide-filter');
      if(body.parentNode!==_bodyHome){ if(_bodyNext&&_bodyNext.parentNode===_bodyHome) _bodyHome.insertBefore(body,_bodyNext); else _bodyHome.appendChild(body); }
      if(_sideEl&&_sideEl.parentNode) _sideEl.parentNode.removeChild(_sideEl);
      btnLabel('Filters');
    }
    // Chips placement. PHONE: the active-filter pills live in an "Applied" section (a fixed block above the
    // scrolling #cvn-fbody, so toggling sections below never shifts them). Wider screens: pills in the bar.
    if(chips){
      restChips();
    }
    renderBar();
    if(document.querySelector('.cvn-fdensity')) _densRender();   // re-clamp density steps to the new grid width (sidebar toggle / breakpoint)
  }
  // In wide mode the pill toggles the on-page sidebar (Hide/Show Filters); in narrow it opens the drawer.
  function onFilterBtn(){ if(isWide()){ _sideHidden=!_sideHidden; cvnSideSave(_sideHidden); applyLayout(); } else { openD(); } }

  document.getElementById('cvn-fopen').addEventListener('click',onFilterBtn);
  document.getElementById('cvn-fclose').addEventListener('click',closeD);
  document.getElementById('cvn-fscrim').addEventListener('click',closeD);
  if(applyBtn) applyBtn.addEventListener('click',closeD);
  clearBtn.addEventListener('click',clearAll);
  sortSel.addEventListener('change',function(){ var pp=curParams(); pp.delete('sort_by'); if(this.value) pp.set('sort_by',this.value); pp.delete('page'); commit(pp); });

  _apply=apply; _closeD=closeD; _drawerEl=drawer; _applyLayoutRef=applyLayout; // expose this page's handlers to the persistent listeners
  _refineRef=function(){ refineCards(); scheduleRefine(); }; // Show more (assets/cvn-show-more.js) appends cards: match their chips to the active colour/size filter

  /* ===== ARRIVE WITH THE PRODUCT TYPES ACTUALLY APPLIED (Shop All) =====
     Not chips that LOOK applied — the filter genuinely on. The page puts all five type values into
     the URL before the first render, so every consumer downstream is reading a real filter state:
     the chips come out of renderChips the ordinary way, "Clear all" appears because a filter really
     is committed, the badge counts five, and the drawer's checkboxes are ticked (they read the URL,
     not the server payload). Nothing here special-cases the pills any more.

     ⚠ NO REFETCH, and that is the point: all five product types IS the whole catalogue, the same
     598 products the server already rendered, so the state changes and the goods do not. replaceState
     (not a redirect, not location.replace) — the shopper pays nothing for arriving filtered.
     Runs before the first renderBar so nothing ever paints the unfiltered state. */
  (function(){
    if(!typePillsOn()) return;
    var tf=findFilter('type'), pp=curParams();
    if(pp.getAll(tf.param).length) return;                 // the URL already says what to show
    tf.values.forEach(function(v){ pp.append(tf.param, v.value); });
    try{ history.replaceState({cvn:1}, '', urlFor(pp)); }catch(e){}
  })();

  renderBar();
  scheduleRefine();
  applyLayout();
  // Swap the Filters button glyph for the adjustments/sliders icon.
  (function(){ var fo=document.getElementById('cvn-fopen'); var svg=fo&&fo.querySelector('svg'); if(svg){ svg.outerHTML='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="14" cy="6" r="2"/><line x1="4" y1="6" x2="12" y2="6"/><line x1="16" y1="6" x2="20" y2="6"/><circle cx="8" cy="12" r="2"/><line x1="4" y1="12" x2="6" y2="12"/><line x1="10" y1="12" x2="20" y2="12"/><circle cx="17" cy="18" r="2"/><line x1="4" y1="18" x2="15" y2="18"/><line x1="19" y1="18" x2="20" y2="18"/></svg>'; } })();
  setupDensity();
  }
  // ---- Grid density (cards per row): pill + slider popover, fixed steps per viewport, cookie-persisted ----
  function _densSquares(n){ var w=n*6+(n-1)*3, r=''; for(var i=0;i<n;i++){ r+='<rect x="'+(i*9)+'" y="0" width="6" height="8" rx="1"/>'; } return '<svg class="cvn-fdens-sq" width="'+w+'" height="8" viewBox="0 0 '+w+' 8" fill="currentColor" aria-hidden="true">'+r+'</svg>'; }
  function _densNoun(){ var el=document.getElementById('cvn-filter-data'), h=''; try{ h=(JSON.parse(el.textContent).handle||'').toLowerCase(); }catch(e){} if(/hoodie/.test(h)) return 'hoodies'; if(/crew|sweatshirt/.test(h)) return 'crewnecks'; if(/t-?shirt|tee/.test(h)) return 't-shirts'; if(/tote/.test(h)) return 'tote bags'; if(/mug|drinkware/.test(h)) return 'mugs'; return 'products'; }
  function _densCookie(k){ var m=document.cookie.match(new RegExp('(?:^|;\\s*)cvn_dens_'+k+'=([0-9]+)')); return m?parseInt(m[1],10):0; }
  function _densRange(){
    if(window.matchMedia('(max-width:749px)').matches) return { key:'p', min:1, max:3, def:2 };
    var g=document.getElementById('product-grid'); var w=g?g.clientWidth:0;
    var fit=w?Math.floor((w+16)/166):6;                 // ~150px card + 16px gap
    var max=Math.max(3, Math.min(6, fit));
    return { key:'d', min:3, max:max, def:(4>max?max:4) };
  }
  function _densApply(n, save){
    var g=document.getElementById('product-grid'), wrap=document.querySelector('.cvn-fdensity'); if(!g||!wrap) return;
    // Own cvn-cN class + our own width rules (CSS). We use Dawn's TECHNIQUE — max-width == width —
    // so flex-grow:1 fills each row EXACTLY (no last-row stretch, no dead space) — but keyed on our
    // own breakpoint (≥750), NOT Dawn's grid--N-col-desktop which only apply at ≥990.
    g.classList.remove('cvn-c1','cvn-c2','cvn-c3','cvn-c4','cvn-c5','cvn-c6');
    g.classList.add('cvn-dens','cvn-c'+n);
    var pill=wrap.querySelector('.cvn-fdens-pill'); if(pill) pill.innerHTML=_densSquares(n);
    var cap=wrap.querySelector('.cvn-fdens-cap'); if(cap){ var noun=_densNoun(); cap.textContent=n+' '+(n===1?noun.replace(/s$/,''):noun)+' per row'; }
    if(save){ var r=_densRange(); document.cookie='cvn_dens_'+r.key+'='+n+';path=/;max-age='+(60*60*24*30)+';samesite=lax'; }
  }
  function _densRender(){
    var wrap=document.querySelector('.cvn-fdensity'), g=document.getElementById('product-grid'); if(!wrap||!g) return;
    var r=_densRange(); var n=_densCookie(r.key)||r.def; if(n<r.min)n=r.min; if(n>r.max)n=r.max;
    var range=wrap.querySelector('.cvn-fdens-range'); range.min=r.min; range.max=r.max; range.value=n;
    wrap.querySelector('.cvn-fdens-lo').innerHTML=_densSquares(r.min);
    wrap.querySelector('.cvn-fdens-hi').innerHTML=_densSquares(r.max);
    wrap.style.display = (r.min===r.max) ? 'none' : '';   // only one column count fits → nothing to choose
    _densApply(n, false);
  }
  function setupDensity(){
    var row=document.querySelector('.cvn-fbar-row'); if(!row || !document.getElementById('product-grid')) return;
    var wrap=row.querySelector('.cvn-fdensity');
    if(!wrap){
      wrap=document.createElement('div'); wrap.className='cvn-fdensity';
      wrap.innerHTML='<button type="button" class="cvn-fdens-btn" aria-haspopup="true" aria-expanded="false" aria-label="Cards per row"><span class="cvn-fdens-pill"></span><svg class="cvn-fdens-caret" viewBox="0 0 20 20" width="13" height="13" aria-hidden="true"><path d="M5 8l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        + '<div class="cvn-fdens-pop"><div class="cvn-fdens-cap"></div><div class="cvn-fdens-row"><span class="cvn-fdens-lo"></span><input type="range" class="cvn-fdens-range" step="1" aria-label="Cards per row"><span class="cvn-fdens-hi"></span></div></div>';
      var sortEl=row.querySelector('.cvn-fsort');
      if(sortEl) row.insertBefore(wrap, sortEl); else row.appendChild(wrap);
      var btn=wrap.querySelector('.cvn-fdens-btn'), pop=wrap.querySelector('.cvn-fdens-pop');
      btn.addEventListener('click', function(e){ e.stopPropagation(); var _s=document.querySelector('.cvn-fsort'); if(_s) _s.classList.remove('is-open'); var open=pop.classList.toggle('is-open'); btn.setAttribute('aria-expanded', open?'true':'false'); });
      document.addEventListener('click', function(e){ if(!wrap.contains(e.target)){ pop.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); } });
      wrap.querySelector('.cvn-fdens-range').addEventListener('input', function(){ _densApply(parseInt(this.value,10), true); });
      if(!window.__cvnDensResize){ window.__cvnDensResize=1; window.addEventListener('resize', function(){ clearTimeout(window.__cvnDensT); window.__cvnDensT=setTimeout(function(){ _densRender(); _fitBar(); }, 200); }); }
      // Observe the bar CONTAINER so _fitBar re-runs the instant the layout settles on first load (rAF/load
      // can fire before the row has its final width — the "opens badly, fixes on scroll" symptom). Observing
      // the container (not the row) is loop-safe: zooming the row doesn't change the full-width container.
      var _fb=row.parentNode;
      if(_fb && window.ResizeObserver && !_fb.__cvnFitRO){ _fb.__cvnFitRO=1;
        try{ new ResizeObserver(function(){ clearTimeout(window.__cvnFitT); window.__cvnFitT=setTimeout(_fitBar, 50); }).observe(_fb); }catch(e){} }
    }
    _densRender();
  }

  // The theme navigates between collection pages WITHOUT a full reload (soft nav), so the script only
  // ran once and new pages came up unwired (Show Filters dead, sort/count empty, filters lost). The
  // guard above marks each drawer data-cvn-wired; these persistent, once-attached listeners re-run
  // initFilter whenever a fresh (unmarked) drawer is swapped in, and delegate global events to the
  // current page's handlers.
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&_drawerEl&&_drawerEl.classList.contains('is-open')&&_closeD) _closeD(); });
  // Close the sort dropdown on any outside click or Escape (class-based, so no per-page closure needed).
  document.addEventListener('click',function(e){ var op=document.querySelector('.cvn-fsort.is-open'); if(op && !e.target.closest('.cvn-fsort')) op.classList.remove('is-open'); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ var op=document.querySelector('.cvn-fsort.is-open'); if(op) op.classList.remove('is-open'); } });
  window.addEventListener('popstate',function(){ if(_apply) _apply(location.pathname+location.search,false); });
  document.addEventListener('cvn:grid-appended',function(){ if(_refineRef) _refineRef(); });
  document.addEventListener('shopify:section:load', initFilter);
  var _rzT; window.addEventListener('resize',function(){ clearTimeout(_rzT); _rzT=setTimeout(function(){ if(_applyLayoutRef) _applyLayoutRef(); }, 150); });
  try{ new MutationObserver(function(){ initFilter(); }).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initFilter); else initFilter();
  // Fit the phone bar on FIRST load too (not just after a filter change): once now, again on window
  // load, and again once web fonts finish (fonts change text width, so an early measure can be wrong).
  requestAnimationFrame(_fitBar);
  window.addEventListener('load', _fitBar);
  try{ if(document.fonts && document.fonts.ready) document.fonts.ready.then(_fitBar); }catch(e){}
})();